import {
  Box,
  Button,
  Container,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { Link as RouterLink } from "react-router-dom";
import Page from "src/components/Page";

const NotAuthorizedView = ({ message, ...rest }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const mobileDevice = useMediaQuery(theme.breakpoints.down("lg"));

  return (
    <Page
      sx={{
        minHeight: "100%",
        py: 6,
        bgcolor: "background.default",
        color: "text.primary",
      }}
      title="403 Forbidden Access"
      {...rest}
    >
      <Container maxWidth="lg">
        <Typography
          align="center"
          variant={mobileDevice ? "h4" : "h1"}
          sx={{ color: "text.primary" }}
        >
          {t("403 Forbidden Access")}
        </Typography>
        <Typography
          align="center"
          variant="subtitle2"
          sx={{ color: "text.primary" }}
        >
          {message
            ? message
            : t(
                "Carece de los permisos necesarios para acceder. " +
                  "Pongase en contacto con su administrador. Hemos enviado un " +
                  "reporte a nuestro centro de seguridad para monitorear su cuenta.",
              )}
        </Typography>
        <Box
          sx={{
            mt: 6,
            display: "flex",
            justifyContent: "center",
          }}
        >
          <img
            alt="Forbidden"
            style={{ maxWidth: "100%", width: 560, height: "auto" }}
            src="/static/images/undraw_authentication_fsn5.svg"
          />
        </Box>
        <Box
          sx={{
            mt: 6,
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Button
            color="secondary"
            component={RouterLink}
            to="/app"
            variant="outlined"
          >
            {t("Volver al inicio")}
          </Button>
        </Box>
      </Container>
    </Page>
  );
};

export default NotAuthorizedView;
